import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { HomeComponent } from '../home/home.component';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.scss']
})
export class GalleryComponent implements OnInit {
  @Input() isgallery: boolean = false;
  iscampus: boolean = false;
  isAccommodation: boolean = false;
  isTreatmentFemale: boolean = false;
  isTreatmentMale: boolean = false;
  isYoga: boolean = false;
  isPhysiotherapy: boolean = false;
  isOnlinebook: boolean = false;
  isOurteam: boolean = false;

  constructor(private route: ActivatedRoute, private router: Router) { }

  // campus: Object[] = [{
  //   image: 'assets/img/campus1.jpeg'
  // }, {
  //   image: 'assets/img/campus5.jpg'
  // }, {
  //   image: 'assets/img/campus15.jpeg'
  // }, {
  //   image: 'assets/img/campus7.jpg'
  // }, {
  //   image: 'assets/img/campus2.jpeg'
  // }, {
  //   image: 'assets/img/campus6.jpeg'
  // }, {
  //   image: 'assets/img/campus4.jpeg'
  // }, {
  //   image: 'assets/img/campus12.jpeg'
  // }, {
  //   image: 'assets/img/campus9.jpeg'
  // }, {
  //   image: 'assets/img/campus10.jpg'
  // }, {
  //   image: 'assets/img/campus13.jpeg'
  // }, {
  //   image: 'assets/img/campus16.jpg'
  // }, {
  //   image: 'assets/img/campus14.png'
  // }, {
  //   image: 'assets/img/campus8.jpg'
  // }, {
  //   image: 'assets/img/campus3.jpg'
  // }, {
  //   image: 'assets/img/campus11.jpg'
  // }
  // ];

  // Accommodation: Object[] = [{
  //   image: 'assets/img/Accommodation1.jpeg'
  // }, {
  //   image: 'assets/img/Accommodation2.jpeg'
  // }, {
  //   image: 'assets/img/Accommodation3.jpeg'
  // }, {
  //   image: 'assets/img/Accommodation6.jpeg'
  // }, {
  //   image: 'assets/img/Accommodation4.jpeg'
  // }, {
  //   image: 'assets/img/Accommodation7.jpeg'
  // }, {
  //   image: 'assets/img/Accommodation5.jpeg'
  // }
  // ];

  // TreatmentFemale: Object[] = [{
  //   image: 'assets/img/TreamentF1.jpeg'
  // }, {
  //   image: 'assets/img/TreamentF7.jpeg'
  // }, {
  //   image: 'assets/img/TreamentF6.jpeg'
  // }, {
  //   image: 'assets/img/TreamentF4.jpeg'
  // }, {
  //   image: 'assets/img/TreamentF2.jpeg'
  // }, {
  //   image: 'assets/img/TreamentF9.jpeg'
  // }, {
  //   image: 'assets/img/TreamentF5.jpeg'
  // }, {
  //   image: 'assets/img/TreamentF3.jpeg'
  // }, {
  //   image: 'assets/img/TreamentF8.jpeg'
  // }, {
  //   image: 'assets/img/TreamentF10.jpeg'
  // }
  // ];

  // TreatmentMale: Object[] = [{
  //   image: 'assets/img/TreamentM1.jpeg'
  // }, {
  //   image: 'assets/img/TreamentM2.jpeg'
  // }, {
  //   image: 'assets/img/TreamentM3.jpeg'
  // }, {
  //   image: 'assets/img/TreamentM4.jpeg'
  // }, {
  //   image: 'assets/img/TreamentM5.jpeg'
  // }, {
  //   image: 'assets/img/TreamentM6.jpeg'
  // }
  // ];

  // yoga: Object[] = [{
  //   image: 'assets/img/Yoga1.jpeg'
  // }, {
  //   image: 'assets/img/Yoga2.jpeg'
  // }, {
  //   image: 'assets/img/Yoga3.jpeg'
  // }, {
  //   image: 'assets/img/Yoga4.jpeg'
  // }, {
  //   image: 'assets/img/Yoga5.jpeg'
  // }, {
  //   image: 'assets/img/Yoga6.jpeg'
  // }
  // ];

  // Physiotherapy: Object[] = [{
  //   image: 'assets/img/PhysiotherapyA3.jpeg'
  // }, {
  //   image: 'assets/img/PhysiotherapyA4.jpeg'
  // }, {
  //   image: 'assets/img/PhysiotherapyA1.jpeg'
  // }, {
  //   image: 'assets/img/PhysiotherapyA2.jpeg'
  // }
  // ];

  // book: Object[] = [{
  //   image: 'assets/img/onlineBook1.jpg'
  // }, {
  //   image: 'assets/img/onlineBook2.jpg'
  // }, {
  //   image: 'assets/img/OnlineBook3.jpg'
  // }, {
  //   image: 'assets/img/OnlineBook4.jpg'
  // }, {
  //   image: 'assets/img/OnlineBook5.jpg'
  // }, {
  //   image: 'assets/img/OnlineBook6.jpg'
  // }, {
  //   image: 'assets/img/OnlineBook7.jpg'
  // }, {
  //   image: 'assets/img/OnlineBook8.jpg'
  // }, {
  //   image: 'assets/img/OnlineBook9.jpg'
  // }, {
  //   image: 'assets/img/OnlineBook10.jpg'
  // }, {
  //   image: 'assets/img/OnlineBook11.jpg'
  // }
  // ];

  // team: Object[] = [{
  //   image: 'assets/img/team1.jpeg'
  // }, {
  //   image: 'assets/img/team6.jpeg'
  // }, {
  //   image: 'assets/img/team5.jpg'
  // }, {
  //   image: 'assets/img/team4.jpg'
  // }, {
  //   image: 'assets/img/team7.jpg'
  // }, {
  //   image: 'assets/img/team3.jpeg'
  // }, {
  //   image: 'assets/img/team2.jpeg'
  // }
  // ];

  hideRow = false;
  GetHomeFuction1(type) {
    this.hideRow = true;
    this.iscampus = false;
    this.isAccommodation = false;
    this.isTreatmentFemale = false;
    this.isTreatmentMale = false;
    this.isYoga = false;
    this.isPhysiotherapy = false;
    this.isOnlinebook = false;
    this.isOurteam = false;
    if (type == 'CAMPUS') {
      this.iscampus = true;
    } else if (type == 'Accommodation') {
      this.isAccommodation = true;
    } else if (type == 'FemaleT') {
      this.isTreatmentFemale = true;
    } else if (type == 'MaleT') {
      this.isTreatmentMale = true;
    } else if (type == 'yoga') {
      this.isYoga = true;
    } else if (type == 'Physiotherapy') {
      this.isPhysiotherapy = true;
    } else if (type == 'book') {
      this.isOnlinebook = true;
    } else if (type == 'team') {
      this.isOurteam = true;
    }
  }

  galleryCards = [
    { type: 'CAMPUS', img: 'assets/img/Home Slider/Office & Medical Block.JPG', title: 'CAMPUS' },
    { type: 'Accommodation', img: 'assets/img/campus16.jpg', title: 'Accommodation' },
    { type: 'FemaleT', img: 'assets/img/Home Slider/Female Therapy Center.JPG', title: 'Treatment Center - Female Dept' },
    { type: 'MaleT', img: 'assets/img/Home Slider/Male Therapy Center.JPG', title: 'Treatment Center - Male Dept' },
    { type: 'yoga', img: 'assets/img/Home Slider/Yoga Hall-1 I.JPG', title: 'Yoga - Yogacharyas' },
    { type: 'team', img: 'assets/img/team1.jpeg', title: 'Our Team' },
    { type: 'book', img: 'assets/img/OnlineBook5.jpg', title: 'Online Book Store' },
    { type: 'Physiotherapy', img: 'assets/img/Home Slider/Physiotherapy.JPG', title: 'Physiotherapy & Acupuncture' }
  ];

  activeCategory: string | null = null;
  galleries: any = {
    CAMPUS: [
      {
        image: 'assets/img/Home Slider/Office & Medical Block.JPG'
      }, {
        image: 'assets/img/Home Slider/Neurotherapy.JPG'
      }, {
        image: 'assets/img/campus5.jpg'
      }, {
        image: 'assets/img/Home Slider/Yoga Hall-2 I.JPG'
      }, {
        image: 'assets/img/campus7.jpg'
      }, {
        image: 'assets/img/campus2.jpeg'
      }, {
        image: 'assets/img/campus6.jpg'
      }, {
        image: 'assets/img/campus4.jpeg'
      }, {
        image: 'assets/img/campus12.jpeg'
      }, {
        image: 'assets/img/Home Slider/Entrance.JPG'
      }, {
        image: 'assets/img/campus10.jpg'
      }, {
        image: 'assets/img/campus13.jpeg'
      }, {
        image: 'assets/img/campus16.jpg'
      }, {
        image: 'assets/img/campus14.png'
      }, {
        image: 'assets/img/Home Slider/Yoga Hall-1 O.JPG'
      }, {
        image: 'assets/img/campus3.jpg'
      }, {
        image: 'assets/img/campus11.jpg'
      }, {
        image: 'assets/img/Home Slider/Annapoorna Dining Hall.jpg'
      }, {
        image: 'assets/img/Home Slider/Ashram Campus-3.JPG'
      }, {
        image: 'assets/img/Home Slider/Ashram Campus-2.JPG'
      }, {
        image: 'assets/img/Home Slider/Wifi Zone.JPG'
      }, {
        image: 'assets/img/Home Slider/Walking Track.JPG'
      }, {
        image: 'assets/img/Home Slider/Recreation.JPG'
      },
    ],
    Accommodation: [
      {
        image: 'assets/img/campus16.jpg'
      }, {
        image: 'assets/img/Accommodation1.jpeg'
      }, {
        image: 'assets/img/Accommodation2.jpeg'
      }, {
        image: 'assets/img/Accommodation3.jpeg'
      }, {
        image: 'assets/img/Accommodation4.jpeg'
      }, {
        image: 'assets/img/Accommodation5.jpeg'
      }
    ],
    FemaleT: [
      {
        image: 'assets/img/Home Slider/Female Therapy Center.JPG'
      }, {
        image: 'assets/img/Home Slider/Pebble Pool.JPG'
      }, {
        image: 'assets/img/TreamentF7.jpeg'
      }, {
        image: 'assets/img/TreamentF6.jpeg'
      }, {
        image: 'assets/img/TreamentF4.jpeg'
      }, {
        image: 'assets/img/TreamentF2.jpeg'
      }, {
        image: 'assets/img/TreamentF9.jpeg'
      }, {
        image: 'assets/img/TreamentF5.jpeg'
      }, {
        image: 'assets/img/TreamentF3.jpeg'
      }, {
        image: 'assets/img/TreamentF8.jpeg'
      }, {
        image: 'assets/img/TreamentF10.jpeg'
      }
    ],
    MaleT: [
      {
        image: 'assets/img/Home Slider/Male Therapy Center.JPG'
      }, {
        image: 'assets/img/TreamentF6.jpeg'
      }, {
        image: 'assets/img/TreamentM1.jpeg'
      }, {
        image: 'assets/img/TreamentM2.jpeg'
      }, {
        image: 'assets/img/TreamentM3.jpeg'
      }, {
        image: 'assets/img/TreamentM4.jpeg'
      }, {
        image: 'assets/img/TreamentM5.jpeg'
      }, {
        image: 'assets/img/TreamentM6.jpeg'
      }
    ],
    yoga: [
      {
        image: 'assets/img/Yoga1.jpeg'
      }, {
        image: 'assets/img/Yoga2.jpeg'
      }, {
        image: 'assets/img/Yoga3.jpeg'
      }, {
        image: 'assets/img/Yoga4.jpeg'
      }, {
        image: 'assets/img/Yoga5.jpeg'
      }, {
        image: 'assets/img/Yoga6.jpeg'
      }, {
        image: 'assets/img/Home Slider/Yoga Hall-1 I.JPG'
      }, {
        image: 'assets/img/Home Slider/Yoga Hall-1 O.JPG'
      }, {
        image: 'assets/img/Home Slider/Yoga Hall-2 I.JPG'
      }, {
        image: 'assets/img/Home Slider/Yoga Hall-2 O.JPG'
      }, {
        image: 'assets/img/Home Slider/Yoga Niketan & Library.JPG'
      }
    ],
    Physiotherapy: [
      {
        image: 'assets/img/Home Slider/Physiotherapy.JPG'
      }, {
        image: 'assets/img/PhysiotherapyA3.jpeg'
      }, {
        image: 'assets/img/PhysiotherapyA4.jpeg'
      }, {
        image: 'assets/img/PhysiotherapyA1.jpeg'
      }, {
        image: 'assets/img/PhysiotherapyA2.jpeg'
      }
    ],
    book: [
      {
        image: 'assets/img/onlineBook1.jpg'
      }, {
        image: 'assets/img/onlineBook2.jpg'
      }, {
        image: 'assets/img/OnlineBook3.jpg'
      }, {
        image: 'assets/img/OnlineBook4.jpg'
      }, {
        image: 'assets/img/OnlineBook5.jpg'
      }, {
        image: 'assets/img/OnlineBook6.jpg'
      }, {
        image: 'assets/img/OnlineBook7.jpg'
      }, {
        image: 'assets/img/OnlineBook8.jpg'
      }, {
        image: 'assets/img/OnlineBook9.jpg'
      }, {
        image: 'assets/img/OnlineBook10.jpg'
      }, {
        image: 'assets/img/OnlineBook11.jpg'
      }
    ],
    team: [
      {
        image: 'assets/img/team1.jpeg'
      }, {
        image: 'assets/img/team6.jpeg'
      }, {
        image: 'assets/img/team5.jpg'
      }, {
        image: 'assets/img/team4.jpg'
      }, {
        image: 'assets/img/team7.jpg'
      }, {
        image: 'assets/img/team3.jpeg'
      }, {
        image: 'assets/img/team2.jpeg'
      }, {
        image: 'assets/img/Accommodation6.jpeg'
      },
    ]
  };

  Title = "";
  GetHomeFuction(type: string, title) {
    this.hideRow = true;
    this.Title = title;
    this.activeCategory = type; // show only selected gallery
  }

  goBack() {
    this.hideRow = false;
    this.activeCategory = null;
    this.Title = "";
  }
  selectedImage: string | null = null;
  selectedIndex: number = -1;   // track current index
  currentGallery: any[] = [];   // track current gallery images

  openImage(img: string, index: number) {
    this.selectedImage = img;
    this.selectedIndex = index;
    this.currentGallery = this.activeCategory ? this.galleries[this.activeCategory] : [];
  }

  closeImage() {
    this.selectedImage = null;
    this.selectedIndex = -1;
    this.currentGallery = [];
  }

  nextImage() {
    if (this.currentGallery.length > 0) {
      this.selectedIndex = (this.selectedIndex + 1) % this.currentGallery.length;
      this.selectedImage = this.currentGallery[this.selectedIndex].image;
    }
  }

  prevImage() {
    if (this.currentGallery.length > 0) {
      this.selectedIndex =
        (this.selectedIndex - 1 + this.currentGallery.length) % this.currentGallery.length;
      this.selectedImage = this.currentGallery[this.selectedIndex].image;
    }
  }

  ngOnInit(): void {
  }
}
